<template>
<div>
    <section class="pt-12 pt-md-14 mt-n11 bg-primary">
    </section>
    <section class="pt-8 pt-md-11 pb-12">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md">
                    <h1 class="display-4 mb-8">Changelog</h1>
                </div>
            </div>
            <div class="row" v-if="loaded">
                <div class="col-12 wiki-content">
                    <div v-for="r in releases" :key="r.version">
                        <h3>Release {{ r.version }}</h3>
                        <p v-if="r.published">{{ formatDate(r.published) }}</p>
                        <div v-html="r.html_content"></div>
                    </div>
                    <p v-if="!releases.length" class="text-muted">No releases yet.</p>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { nextTick } from 'vue';
import { highlightAll } from '../js/highlight';

export default {
    data() {
        return {
            releases: [],
            loaded: false,
        }
    },
    methods: {
        formatDate(d) {
            const date = new Date(Number(d) * 1000)
            const dd = String(date.getUTCDate()).padStart(2, '0')
            const mm = String(date.getUTCMonth() + 1).padStart(2, '0')
            const yyyy = date.getUTCFullYear()
            return `${dd}.${mm}.${yyyy}`
        }
    },
    created() {
        this.$services.Releases().get({full: true}).then(resp => {
            this.releases = resp.body
            this.loaded = true
            nextTick(() => highlightAll())
        })
        // this.$methods.updateSEOMeta({
        //     title: 'Changelog',
        //     description: 'DataLikers changelog. Latest updates, new endpoints, bug fixes, and improvements for the Instagram & TikTok Data API.',
        //     keywords: 'changelog, updates, release notes, DataLikers updates, new features, Instagram API updates, TikTok API updates',
        // }, '/changelog')
    },
}
</script>

<style scoped>
.wiki-content :deep(pre) {
    background: #1e1e1e;
    border-radius: 6px;
    padding: 1.25rem;
    margin-bottom: 1.5rem;
    overflow-x: auto;
    white-space: pre;
}

.wiki-content :deep(pre code) {
    display: block;
    font-size: 0.85rem;
    line-height: 1.6;
    white-space: pre;
}
</style>
